import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import { Button } from 'carbon-components-react';
import {
  OverflowMenuHorizontal16,
  Events32,
  UserMultiple32,
  ReportData32,
  Add32,
  Unknown32
} from '@carbon/icons-react';
import { UpgradeModal } from 'components';

const Upgrade: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const preview = queryParams.get('preview');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleUpgradePlanClick = () => {
    setIsModalOpen(true);
  };

  const pageTitle: any = {
    teams: 'Organising teams',
    reporting: 'Generating reports',
    users: 'Managing users',
    create: 'Creating new enquiries'
  };
  const descriptions: any = {
    teams: `Teams helps your users collaborate, providing shared workspaces for enquiries based on geographic extent. 
    By adding enquiries to Teams it becomes easier for groups of users to search and manage responses.`,
    reporting: `This tool provides a collection of pre-defined reports that make reporting on enquiries at the team or user level quick and easy. 
    Reports can be generated in a format that suits you based on your criteria.`,
    users: `This is where you can centrally manage the users associated with your account. 
    Invite and manage users, assign roles and control your enterprise access with a robust set of capabilities.`,
    create: `To lodge enquiries from SmarterWX Locate, you must register as a BYDA Member and be authorised to use the BYDA API.`
  };

  let icon;
  switch (preview) {
    case 'teams':
      icon = <Events32 />;
      break;
    case 'reporting':
      icon = <ReportData32 />;
      break;
    case 'users':
      icon = <UserMultiple32 />;
      break;
    case 'create':
      icon = <Add32 />;
      break;
    default:
      icon = <Unknown32 />;
      break;
  }

  return (
    <div id="Upgrade" data-testid="Upgrade" className="upgrade">
      <FullHeaderLeftSideFullPanelLayout enableHeaderGlobalBar={true}>
        <div className="upgrade-page-title">
          {preview && pageTitle[preview]}
        </div>
        <div className="upgrade-content-wrapper">
          <div className="upgrade-content-image">
            <img
              src={`./${preview}/vpa-${preview}-r.png`}
              srcSet={`./${preview}/vpa-${preview}-r.png, ./${preview}/vpa-${preview}-r@2x.png 2x, ./${preview}/vpa-${preview}-r@3x.png 3x`}
              alt={`${preview && pageTitle[preview]} page sample`}
              title="Sample"
            />
          </div>
          <div
            className={`upgrade-content-descriptions-wrapper spacing-${preview}`}
          >
            <div className={`descriptions-image spacing desc-${preview}`}>
              {icon}
              <div>
                {preview === 'reporting'
                  ? 'reports'
                  : preview === 'create'
                  ? 'Create new enquiries in bulk'
                  : preview}
              </div>
            </div>
            <div>
              <div className="descriptions-wording spacing">
                {preview && descriptions[preview]}
              </div>
              <div className="descriptions-button">
                {preview !== 'create' && (
                  <Button
                    kind="tertiary"
                    renderIcon={OverflowMenuHorizontal16}
                    onClick={handleUpgradePlanClick}
                  >
                    Upgrade my plan
                  </Button>
                )}
                {preview === 'create' && (
                  <Button
                    kind="tertiary"
                    renderIcon={OverflowMenuHorizontal16}
                    href={'https://www.byda.com.au/become-a-member/join/'}
                    target={'_blank'}
                    className="become-byda-member-button"
                  >
                    Become a BYDA member
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        <UpgradeModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default React.memo(Upgrade);
